import * as React from 'react';

import type {GetSuggestedReplies_suggestedReplies as SuggestedReplies} from 'nutshell-graphql-types';

type TimelineEmailContextType = {
    suggestedEmailReplies: SuggestedReplies | null | undefined;
    isLoadingSuggestedReplies: boolean;
    allowSuggestedReplies: boolean;
    onReply: (suggestedEmailReplyId?: string) => void;
};

const TimelineEmailContext = React.createContext<TimelineEmailContextType | null>(null);

type Props = {
    children: React.ReactNode;
    suggestedEmailReplies: SuggestedReplies | null | undefined;
    allowSuggestedReplies: boolean;
    isLoadingSuggestedReplies: boolean;
    onReply: (suggestedEmailReplyId?: string) => void;
};

export function TimelineEmailProvider(props: Props) {
    const {
        children,
        suggestedEmailReplies,
        allowSuggestedReplies,
        isLoadingSuggestedReplies,
        onReply,
    } = props;

    const value = React.useMemo(
        () => ({
            suggestedEmailReplies,
            allowSuggestedReplies,
            isLoadingSuggestedReplies,
            onReply,
        }),
        [suggestedEmailReplies, allowSuggestedReplies, isLoadingSuggestedReplies, onReply]
    );

    return <TimelineEmailContext.Provider value={value}>{children}</TimelineEmailContext.Provider>;
}

export function useTimelineEmail(): TimelineEmailContextType | null {
    const context = React.useContext<TimelineEmailContextType | null>(TimelineEmailContext);

    return context;
}
